const typeMixins = {
  methods: {
    isNumber(e) {
      const evt = e || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57 || charCode === 110 || charCode === 190)) && charCode !== 46) {
        evt.preventDefault();
        return false;
      }
      return true;
    },

    ifPhoneNumber(method) {
      if (this.$store.state.paymentMethods.filter((x) => x.number).map((x) => x.slug).includes(method)) {
        return true;
      }
      return false;
    },
  },
};

export default typeMixins;
